import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class InsightsRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getUserInsights() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/insight`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getUserTradingPlan() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/insight/trading-plan`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    modifyInsightState(newInsightState) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight`, newInsightState,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createTradingPlan(brokerAccountId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/insight/trading-plan-insights/${brokerAccountId}`, null,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Trades Number Restriction
    modifyTradesNumberRestriction(newTradesNumberRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/trade-number-restriction`, newTradesNumberRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Negative Trades Restriction
    modifyNegativeTradesRestriction(newNegativeTradesRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/negative-trade-number-restriction`, newNegativeTradesRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Target Result
    modifyTargetExpectedResult(newTargetResult) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/profit-target`, newTargetResult,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Trade Loss Restriction
    modifyTradeLossRestriction(newTradeLossRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/loss-per-trade-restriction`, newTradeLossRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Period Loss Restriction
    modifyPeriodLossRestriction(newPeriodLossRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/loss-restriction`, newPeriodLossRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Trade Duration Restriction
    modifyTradeDurationRestriction(newTradeDurationRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/trade-duration-restriction`, newTradeDurationRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Overnight Restriction
    modifyOvernightRestriction(newOvernightRestriction) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/is-overnight-restriction`, newOvernightRestriction,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Trading Days Restriction
    modifyTradingDaysRestriction(calendarSettings) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/trading-days-restriction`, calendarSettings,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    // Pre Market Routine
    modifyPreMarketRoutine(newPreMarketRoutine) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/insight/pre-market-routine`, newPreMarketRoutine,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new InsightsRepository();
